export const EVENTS = {
  VISIT: "portfolio_visit",
  VISIT_DURATION: "visit_duration",
};

export const PARAMS = {
  DURATION_MINUTES: "duration_minutes",
};

const ANALYTICS_EXCLUSION_KEY = "sandbox_analytics_excluded";
const DATALAYER_NAME = "dataLayer";

let analytics = null;

const isAnalyticsExcluded = () => {
  if (typeof window === "undefined") return true;

  const isLocalHost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  const isOptedOut =
    window.localStorage.getItem(ANALYTICS_EXCLUSION_KEY) === "true";

  return isLocalHost || isOptedOut;
};

export const setAnalyticsExclusion = (isExcluded) => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(
    ANALYTICS_EXCLUSION_KEY,
    isExcluded ? "true" : "false"
  );
};

const pushToDataLayer = (eventName, params = {}) => {
  if (typeof window === "undefined" || isAnalyticsExcluded()) return;

  window[DATALAYER_NAME] = window[DATALAYER_NAME] || [];
  window[DATALAYER_NAME].push({
    event: eventName,
    ...params,
  });
};

// GTM is now the single tracking layer. These helpers stay available so
// existing imports remain stable and future custom events can use dataLayer.
export const initAnalyticsSession = async () => null;
export const logVisitDuration = (durationMinutes) => {
  if (typeof durationMinutes !== "number") return;
  pushToDataLayer(EVENTS.VISIT_DURATION, {
    [PARAMS.DURATION_MINUTES]: durationMinutes,
  });
};
export const logTabSwitch = () => {};
export const logCertificateZoom = () => {};
export const logFeatureUse = () => {};
export const logError = () => {};

export { analytics };
